//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { CookieKeys } from '../consts';
import { CookieService } from 'ngx-cookie-service';
import { ExceptionsService } from './utelize/general/exceptions-service';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })

export class LanguageService {

  public languages: string[]=['en', 'es', 'de', 'it', 'ru'];

  constructor(
    private exceptionsService: ExceptionsService,
    private cookieService    : CookieService,
    private translate        : TranslateService
  ) {
    try {
      let browserLang: any;
      
      this.translate.addLangs(this.languages);
      
      if (this.cookieService.check(CookieKeys.Language)) {
        browserLang=this.cookieService.get(CookieKeys.Language);
      } else {
        browserLang=translate.getBrowserLang();
      }
      
      translate.use(browserLang.match(/en|es|de|it|ru/) ? browserLang : 'en');
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public setLanguage(lang: any) {
    try {
      this.translate.use(lang);
      this.cookieService.set(CookieKeys.Language, lang);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
}
